import { Trash2 } from "lucide-react";
import { fmtDate } from "../lib/measurements";

export const MeasurementList = ({ points, interventions, sfx, canEdit, onDelete }) => {
  if (!points.length) return <p className="text-sm text-zinc-400 py-6" data-testid="measurement-list-empty">Nog geen metingen. Begin met een of meer nulmetingen.</p>;
  const ivName = (n) => interventions.find((i) => i.nummer === n)?.omschrijving || "";
  return (
    <table className="w-full text-sm" data-testid="measurement-list">
      <thead>
        <tr className="border-b border-zinc-900 text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500">
          <th className="py-2 w-12">#</th><th>Datum</th><th>Soort</th><th className="text-right pr-6">Waarde</th><th className="hidden sm:table-cell">Opmerking</th><th className="w-8" />
        </tr>
      </thead>
      <tbody>
        {[...points].reverse().map((p) => (
          <tr key={p.id} className="border-b border-zinc-200 hover:bg-zinc-50 transition-colors" data-testid={`measurement-row-${p.nr}`}>
            <td className="py-2.5 font-mono text-zinc-400">{String(p.nr).padStart(2, "0")}</td>
            <td>{fmtDate(p.t)}</td>
            <td>{p.soort === "nulmeting"
              ? <span className="inline-block border border-zinc-400 px-1.5 text-xs">Nulmeting</span>
              : <span className="text-xs"><span className="bg-zinc-900 text-white px-1.5 mr-1">I{p.interventie_nummer}</span>{ivName(p.interventie_nummer)}</span>}</td>
            <td className="text-right pr-6 font-grotesk font-semibold">{p.waarde}{sfx}</td>
            <td className="hidden sm:table-cell text-zinc-500">{p.opmerking}</td>
            <td>{canEdit && (
              <button onClick={() => onDelete(p.id)} className="text-zinc-400 hover:text-zinc-900" data-testid={`measurement-delete-${p.nr}`}><Trash2 className="h-4 w-4" /></button>
            )}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
